/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Credits_SceneInputs */

const en_admin_credits_scene = /** @type {(inputs: Admin_Credits_SceneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scene`)
};

const zh_admin_credits_scene = /** @type {(inputs: Admin_Credits_SceneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`场景`)
};

/**
* | output |
* | --- |
* | "Scene" |
*
* @param {Admin_Credits_SceneInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_credits_scene = /** @type {((inputs?: Admin_Credits_SceneInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Credits_SceneInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_credits_scene(inputs)
	return zh_admin_credits_scene(inputs)
});
export { admin_credits_scene as "admin.credits.scene" }